var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { PureComponent } from "react";
import debounce from "debounce-promise";
import Select from "@irati/ui/src/FormItem/Select";
import UsersForBusiness, { userList, getNextPage } from "@irati/identity/apollo/query/UsersForBusiness";
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname";
import ProfilePic from "@irati/ui/src/ProfilePicture";
/* eslint-disable no-restricted-imports */
/** @description: Tech debt, this should be moved outside the ui folder */
import authentication from "@irati/auth";
import FormattedMessage from "@irati/utils/lang";
import getUserSearchText from "./UserSearchText";
import UserRowDeactivated from "./UserRow/Deactivated";
var MIN_SEARCH_LENGTH = 3;
var UserSearch = /** @class */ (function (_super) {
    __extends(UserSearch, _super);
    function UserSearch(props) {
        var _this = _super.call(this, props) || this;
        _this.getPromptText = function () {
            var searchString = _this.state.searchString;
            if (searchString && searchString.length >= MIN_SEARCH_LENGTH) {
                return React.createElement(FormattedMessage, { id: "platform.global.noUsersFound" });
            }
            return React.createElement(FormattedMessage, { id: "platform.fields.selectRecipient.underCharLimit" });
        };
        _this.shouldIncludeUser = function (option) {
            var _a;
            if ((((_a = _this.state.searchString) === null || _a === void 0 ? void 0 : _a.length) || MIN_SEARCH_LENGTH + 1) < MIN_SEARCH_LENGTH) {
                return false;
            }
            if (_this.props.removeSelf) {
                var currentUser = authentication.user();
                return currentUser.uuid !== option.data.uuid;
            }
            return true;
        };
        _this.handleChange = function (key, object) {
            return _this.props.onChange(key, object);
        };
        _this.updateSearch = function (searchString) { return _this.setState(function (_a) {
            var variables = _a.variables;
            if (((searchString === null || searchString === void 0 ? void 0 : searchString.length) || 0) >= MIN_SEARCH_LENGTH) {
                variables.searchString = searchString;
            }
            else {
                delete variables.searchString;
            }
            return { variables: variables };
        }); };
        _this.handleSearch = function (searchString, _a) {
            var action = _a.action;
            if (action === "input-change") {
                _this.setState({ searchString: searchString }, function () {
                    _this.updateSearch(searchString);
                });
            }
            else if (action === "set-value" || action === "input-blur") {
                _this.setState({ searchString: undefined }, function () {
                    _this.updateSearch(null);
                });
            }
        };
        _this.state = {
            variables: { businessId: props.businessId || authentication.business().uuid }
        };
        _this.updateSearch = debounce(_this.updateSearch, 500);
        return _this;
    }
    UserSearch.prototype.render = function () {
        var _this = this;
        var _a = this.state, variables = _a.variables, searchString = _a.searchString;
        var selectProps = {
            id: this.props.id,
            name: this.props.name,
            isMulti: this.props.isMulti,
            label: this.props.label,
            hideLabel: this.props.hideLabel,
            placeholder: this.props.placeholder,
            value: this.props.value,
            isDisabled: this.props.isDisabled,
            autoFocus: this.props.autoFocus,
            controlShouldRenderValue: this.props.controlShouldRenderValue
        };
        return (React.createElement(UsersForBusiness, { useLoader: false, useError: false, variables: variables }, function (apollo) { return (React.createElement(Select, __assign({}, selectProps, { options: userList(apollo).results, inputValue: searchString, onInputChange: _this.handleSearch, filterOption: _this.shouldIncludeUser, onMenuScrollToBottom: function () { return getNextPage(apollo, variables); }, isLoading: apollo.loading, onChange: _this.handleChange, getOptionLabel: function (user) { return firstnameLastname(user); }, getOptionValue: function (user) { return user.uuid; }, autoComplete: false, components: {
                OptionIcon: function (user) {
                    return React.createElement(ProfilePic, { user: user, marginRight: true, small: true, deactivated: !user.isEnabled });
                },
                OptionLabel: function (user) {
                    return React.createElement(React.Fragment, null,
                        firstnameLastname(user),
                        " ",
                        React.createElement(UserRowDeactivated, { isEnabled: user.isEnabled }));
                },
                NoOptionsMessage: getUserSearchText(_this.getPromptText())
            } }))); }));
    };
    UserSearch.getDerivedStateFromProps = function (props, state) {
        var variables = __assign(__assign({}, state.variables), { businessId: props.businessId || authentication.business().uuid, adminsOnly: props.adminsOnly, teamIds: props.teamIds });
        if (props.enabledOnly !== false) {
            variables.enabled = true;
        }
        return { variables: variables };
    };
    return UserSearch;
}(PureComponent));
export default UserSearch;
